import { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import styled, { keyframes } from 'styled-components';

const blink = keyframes`
	0% {
		opacity: 0;
	}

	50% {
		opacity: 0.25;
	}

	100% {
		opacity: 0;
	}
`;

const Highlight = styled.div`
	position: absolute;
	background: ${(props) => props.theme.colors.blue};
	opacity: 0;
	border-radius: 5px;
	top: -20px;
	bottom: -20px;
	left: -20px;
	right: -20px;
	pointer-events: none;

	animation: 1s linear ${blink};
	animation-iteration-count: 5;
`;

export default function HashLight(
	props: PropsWithChildren<{
		name: string;
	}>,
) {
	const ref = useRef<HTMLDivElement>(null);

	const [match, setMatch] = useState(false);

	const location = useLocation();

	useEffect(() => {
		if (location.hash.split('#')[1] === props.name) {
			ref.current?.scrollIntoView({
				block: 'center',
			});

			setMatch(true);
		} else {
			setMatch(false);
		}
	}, [location.hash]);

	return (
		<div style={{ position: 'relative' }} ref={ref}>
			{props.children}
			{match && <Highlight />}
		</div>
	);
}
